import { render, staticRenderFns } from "./ftp-actions.vue?vue&type=template&id=68b49471&scoped=true&"
import script from "./ftp-actions.vue?vue&type=script&lang=js&"
export * from "./ftp-actions.vue?vue&type=script&lang=js&"
import style0 from "./ftp-actions.vue?vue&type=style&index=0&id=68b49471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b49471",
  null
  
)

export default component.exports